const getters = {
  // 门户配置
  websiteInfo: state => state.website.info,
  // 企业信息
  enterpriseId: state => state.enterprise.enterpriseId,
  empName: state => state.enterprise.empName,
  entpName: state => state.enterprise.empName,
  empNameState: state => state.enterprise.empName, //旧代码部分地方已使用empName变量，则get empNameState
  webIco: state => state.enterprise.webIco,
  webIeIco: state => state.enterprise.webIeIco,
  entpWebsite: state => state.enterprise.entpWebsite,
  studyQrCode: state => state.enterprise.studyQrCode,
  entpTel: state => state.enterprise.entpTel,
  entpType: state => state.enterprise.entpType,
  // 用户信息
  avatar: state => state.user.avatar,
  nickName: state => state.user.nickName,
  isLogin: state => state.user.isLogin,
  isLoginState: state => state.user.isLogin, //旧代码部分地方已使用isLogin变量，则get isLoginState
  isEnterPrise: state => state.user.isEnterPrise,
  userType: state => state.user.userType,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js